import { DashboardAPI } from "utils/api";

export const loginUserAPI = async ({ idToken }) =>
    DashboardAPI({
        method: "POST",
        url: "/loginUser",
        data: {
            idToken,
        },
    }); //.catch((err) => console.log(err.message));

export const checkUserSessionAPI = async () =>
    DashboardAPI({
        method: "POST",
        url: "/checkSession",
    }); //.catch((err) => console.log(err.message));

export const logoutUserAPI = async () =>
    DashboardAPI({
        method: "POST",
        url: "/logoutUser",
    }).catch((err) => console.log(err));

export const resetPasswordLinkAPI = async (email) =>
    DashboardAPI({
        method: "POST",
        url: "/resetPasswordLink",
        data: {
            email,
        },
    });

export const changeUserPassword = async ({ oldPassword = "", newPassword = "" }) =>
    DashboardAPI({
        method: "POST",
        url: "/changeUserPassword",
        data: {
            oldPassword,
            newPassword,
        },
    }).catch((err) => {
        return { status: 500, err, data: {} };
    });
